/**
 * A printer tab strip driven by the `?printer=` URL param (see `usePrinterTab`).
 *
 * Tabs are every enabled shared printer configured on this PC plus a
 * "Browser dialog" tab. When a printer tab is active, pages print to it through
 * the local agent; "Browser dialog" keeps the old behaviour.
 */
import { PRINT_DIALOG_TARGET, usePrinterTab } from '../../hooks/usePrinterTab';

export function PrinterTabs({ defaultId }: { defaultId?: string }) {
  const { printers, activeId, setActiveId } = usePrinterTab(defaultId);

  const cls = (active: boolean) =>
    active
      ? 'px-3 py-1.5 rounded-md text-xs font-medium bg-primary text-white'
      : 'px-3 py-1.5 rounded-md text-xs font-medium text-text-muted hover:bg-surface hover:text-text transition-colors';

  return (
    <div className="inline-flex flex-wrap items-center gap-1 rounded-lg border border-border bg-background p-1">
      {printers.map((d) => (
        <button
          key={d.id}
          type="button"
          onClick={() => setActiveId(d.id)}
          className={cls(activeId === d.id)}
          title={`\\${d.networkIp || d.pcName || 'localhost'}\\${d.shareName}`}
        >
          {d.name || d.shareName}
        </button>
      ))}
      <button
        type="button"
        onClick={() => setActiveId(PRINT_DIALOG_TARGET)}
        className={cls(activeId === PRINT_DIALOG_TARGET)}
        title="Open the browser print dialog and pick any installed printer"
      >
        Browser dialog
      </button>
    </div>
  );
}
